import { Method } from '@rxap/utilities';
import { OpenApiMethod, HttpMethods, BaseOpenApiMethod } from '../../open-api.method';
import { WithdrawalControllerSubmitRequestBody } from '../../request-bodies/withdrawal-controller-submit.request-body';
import { WithdrawalControllerSubmitResponse } from '../../responses/withdrawal-controller-submit.response';

interface WithdrawalControllerSubmitOpenApiParameters {
  requestBody: WithdrawalControllerSubmitRequestBody;
}

@OpenApiMethod({
  method: HttpMethods.POST,
  apiName: 'withdrawal',
  path: '/withdrawal',
  operationId: 'WithdrawalController_submit',
  parameters: [],
})
export class WithdrawalControllerSubmitMethod
  extends BaseOpenApiMethod<WithdrawalControllerSubmitResponse>
  implements Method<WithdrawalControllerSubmitResponse, WithdrawalControllerSubmitOpenApiParameters>
{
  public call(parameters: WithdrawalControllerSubmitOpenApiParameters): Promise<WithdrawalControllerSubmitResponse> {
    return super.call(parameters);
  }
}
